import React from 'react';

import { Link as LinkIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { CompanyType } from 'src/api';
import { DetailPageLayout } from 'src/components/common';
import { EmployeeDataSearchScreen } from 'src/components/employee';
import {
  getEmployerInviteLinkArgs,
  useCopyEmployeeInviteLink,
  useEmployeeDataSearch,
  useResendEmployeeInvite,
} from 'src/hooks/employee';
import { useEmployerById, useEmployerParamId } from 'src/hooks/employer';
import { useCurrentUserPermissions } from 'src/hooks/user';

export const EmployersEmployeePage: React.FC = () => {
  const employerId = useEmployerParamId();
  const { employer } = useEmployerById(employerId);

  const { hasPlatformRoles } = useCurrentUserPermissions();

  const search = useEmployeeDataSearch({
    scope: hasPlatformRoles ? 'admin' : 'employerScope',
    skip: !employerId,
    companyFilter: employerId
      ? { companyType: CompanyType.Employer, companyId: employerId }
      : undefined,
  });

  const baseInviteLinkArgs = getEmployerInviteLinkArgs(employer);
  const inviteLinkArgs = baseInviteLinkArgs
    ? { ...baseInviteLinkArgs, entityDisplayName: employer?.displayName }
    : null;
  const copyInviteLink = useCopyEmployeeInviteLink(inviteLinkArgs);
  const resendInvite = useResendEmployeeInvite('cvStaff');

  return (
    <DetailPageLayout
      titleContent="Employees"
      topRightContent={
        <Button startIcon={<LinkIcon />} onClick={copyInviteLink}>
          Copy signup link
        </Button>
      }
    >
      <EmployeeDataSearchScreen
        {...search}
        allowEmailSearch
        enableAdminControls={hasPlatformRoles}
        inviteLinkArgs={inviteLinkArgs}
        inviteEmailOptionsScope={hasPlatformRoles ? 'admin' : 'employerScope'}
        sendInviteScope="cvStaff"
        onResendInvite={resendInvite}
      />
    </DetailPageLayout>
  );
};
